import { MastraClient } from "@mastra/client-js";

import { getAIAuthToken } from "../utils/authToken";

export const clientRequest = async <T = unknown>(
  request: (client: MastraClient) => Promise<T>
) => {
  const token = await getAIAuthToken();

  const client = new MastraClient({
    baseUrl: import.meta.env.REACT_APP_AI_API_URL,
    apiPrefix: "/ai/agents",
    headers: {
      Authorization: token
    }
  });

  return request(client);
};
